module.exports = __webpack_public_path__ + "img/expostyle_0024_blue_jean_pantone7667c.76560517.jpg";